import yaml from 'js-yaml';
import type { ParsedFrontmatter } from './rules/types';

const FRONTMATTER_OPEN = /^---\s*\r?\n/;

export function parseSkillMd(rawInput: string): ParsedFrontmatter {
  const input = rawInput.replace(/^\uFEFF/, '');

  if (!FRONTMATTER_OPEN.test(input)) {
    return {
      frontmatter: {},
      body: input.trim(),
      rawFrontmatter: '',
      parseError: 'No frontmatter delimiters found. SKILL.md must start with `---`.',
    };
  }

  const afterOpen = input.replace(FRONTMATTER_OPEN, '');
  const closeMatch = afterOpen.match(/\r?\n---\s*(\r?\n|$)/);

  if (!closeMatch || closeMatch.index === undefined) {
    return {
      frontmatter: {},
      body: afterOpen.trim(),
      rawFrontmatter: afterOpen,
      parseError: 'Frontmatter is missing its closing `---` delimiter.',
    };
  }

  const rawFrontmatter = afterOpen.slice(0, closeMatch.index);
  const body = afterOpen.slice(closeMatch.index + closeMatch[0].length).trim();

  let frontmatter: Record<string, unknown> = {};
  let parseError: string | null = null;

  try {
    const parsed = yaml.load(rawFrontmatter, { schema: yaml.FAILSAFE_SCHEMA });
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      frontmatter = parsed as Record<string, unknown>;
    } else if (parsed !== null && parsed !== undefined) {
      parseError = 'Frontmatter must be a YAML object (key/value pairs).';
    }
  } catch (err) {
    parseError = err instanceof Error ? err.message : 'Could not parse YAML frontmatter.';
  }

  return { frontmatter, body, rawFrontmatter, parseError };
}

export function asString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}
